import styled from 'styled-components';
import { Badge } from 'newcomponents/UI/Badge';

export const Container = styled.div`
  height: 100%;
  display: flex;
  text-align: left;
  flex-direction: column;
  position: relative;
  background: var(--v3-black-2);

  .loading__container {
    z-index: 1;
    background: #ffffff21;
    backdrop-filter: blur(2px);
  }

  &.betslipBody {
    overflow-y: auto;
    overflow-x: hidden;
    height: auto;
    flex: 1;
    max-height: 100%;
    position: relative;
  }
`;

export const Header = styled.div<{
  shadow?: boolean;
  content?: 'flex-end' | 'space-between';
  $isAdvanced?: boolean;
}>`
  top: 0;
  z-index: 2;
  height: 48px;
  display: flex;
  font-size: 14px;
  position: sticky;
  font-weight: 600;
  align-items: center;
  padding: 12px;
  letter-spacing: 0.42px;
  color: var(--v3-text-color);
  justify-content: ${props => props.content || 'space-between'};
  background-color: var(--v3-black-0);
  ${props =>
    props.shadow &&
    ` margin-bottom: 1px;
      box-shadow: var(--v3-shadow-1-down);
    `}
  ${props =>
    props.$isAdvanced
      ? `
         padding: 8px 12px 0 0;
         height: unset
        `
      : ''}
  .betslipFeatureSwitcher {
    padding: 0;
  }
`;

export const FooterContainer = styled.div`
  flex-direction: column;
  display: flex;
  padding: 12px;
  & > button {
    flex: 1;
  }
`;

export const FooterLabel = styled.div`
  color: var(--v3-text-color);
  font-size: 12px;
  line-height: 16px;
`;

export const FooterItem = styled.div<{
  isSingle?: boolean;
  totalReturn?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  ${props => (props.isSingle ? ` margin-bottom: 0;` : ` margin-bottom: 12px;`)}
  ${props =>
    props.totalReturn &&
    `
      padding: 12px 0;
      border-top: 1px solid var(--v3-black-6);
      border-bottom: 1px solid var(--v3-black-6);
    `}
`;

export const Link = styled.div`
  font-size: 11px;
  font-weight: 400;
  letter-spacing: 0.33px;
  color: var(--v3-text-color);
  cursor: pointer;
`;

export const BetButtonWrapper = styled.div`
  display: flex;
  padding: 0 8px 12px 8px;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  background-color: var(--v3-black-0);
  justify-content: flex-end;
`;

export const BetBadge: typeof Badge = styled(Badge)`
  display: flex;
  flex: 1;
`;

export const FreeBetAmountLabel = styled.div`
  font-size: 14px;
  color: var(--v3-text-color);
  font-weight: 600;
`;

export const FreeBetAmountWrapper = styled(FooterItem)`
  border-bottom: 1px solid var(--v3-primary-2);
  padding-bottom: 12px;
`;

export const BetsWrapper = styled.div`
  background-color: var(--v3-black-6);
  text-align: left;
`;

export const OpenBetsWrapper = styled.div`
  margin-bottom: 4px;
  border-radius: 4px;
  box-shadow: var(--v3-shadow-2);
`;

export const FooterValue = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 20px;
  font-weight: 600;
  color: var(--v3-text-color);
`;

export const ResultValue = styled.div`
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.42px;
  color: var(--v3-primary-6);
`;
